import React, { useState, useEffect } from 'react';
import { Card, Button, Form, Row, Col, Table, Modal } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import defaultImg from './../../../images/task/img1.jpg';
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const BillingMaster = () => {
  const tableHeaders = ["#", "Supplier", "Bill Number",  "Bill Date", "Due Date", "Status", "Action"];
  const [billingData, setBillingData] = useState([]);
  const [showForm, setShowForm] = useState(false); 
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
    const warehouse_id = localStorage.getItem("warehouse_id");

  const [formData, setFormData] = useState({
    id: null,
    supplier_id: "",
    order_no: "",
    warehouse_id: warehouse_id,
    bill_date: "",
    due_date: "",
    sub_total: "",
    discount:"",
    grand_total:"",
    remarks:"",
    status: 0,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [supplierData, setSupplierData] = useState([]);
  const [grnData, setGrnData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
// For Bulk Modal
const [showBulkModal, setShowBulkModal] = useState(false);
const [bulkSearch, setBulkSearch] = useState("");
const [bulkItems, setBulkItems] = useState([]); // selected items with qty
const [showCancelConfirm, setShowCancelConfirm] = useState(false);
const [showDraftDetails, setShowDraftDetails] = useState(false);
const [selectedDraft, setSelectedDraft] = useState(null);
  
const navigate = useNavigate();


  useEffect(() => {
    loadInitialData();
    fetchSupplierData();
    fetchGrnData();
    fetchProductData();
    fetchCustomerData();
    fetchGrnDetails();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchBillingData();
    } catch {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

const formatDate = (dateString) => {
  if (!dateString) return "-";
  const d = new Date(dateString);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};


  const fetchBillingData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart-billing/getby-warehouse/${warehouse_id}`);
      setBillingData(res.data || []);
    } catch {
      toast.error("Failed to fetch billing data");
    }
  };

  const fetchSupplierData = async () => {
  try {
    const res = await axios.get(`${var_api}ci_veemart_supplier_master/get`);
    const suppliers = Array.isArray(res.data) ? res.data : res.data.data || [];
    setSupplierData(suppliers);
  } catch (err) {
    console.error("Failed to fetch suppliers:", err);
    toast.error("Failed to fetch supplier data");
  }
};

const getSupplierName = (id) => {
  const supplier = supplierData.find((s) => s.id === id);
  return supplier ? supplier.supplier_name : "-";
};

const fetchGrnData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_grn/get`);
    let data = Array.isArray(res.data) ? res.data : res.data.data || [];

    // Sort by latest ID first
    data = data.sort((a, b) => b.id - a.id);

    setGrnData(data);
  } catch {
    toast.error("Failed to fetch GRN data");
  }
};

const fetchGrnDetails = async (grn_id) => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_grn_details/getByGrnId/${grn_id}`);
    return res.data || [];
  } catch (err) {
    console.error("Failed to fetch GRN details", err);
    return [];
  }
};



const fetchProductData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
    const allProducts = Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data.data)
      ? res.data.data
      : [];
    setProductData(allProducts);
  } catch (err) {
    toast.error("Failed to fetch product data");
  }
};

  const fetchCustomerData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart_instore_customers/get`);
      setCustomerData(res.data || []);
    } catch {
      toast.error("Failed to fetch customer data");
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleAddClick = () => {
    setFormData({
      supplier_id: "",
    order_no: "",
    warehouse_id: warehouse_id,
    bill_date: "",
    due_date: "",
    sub_total: "",
    discount:"",
    grand_total:"",
    remarks:"",
    status: 0,
    });
    setFile(null);
    setIsEditMode(false);
    setErrors({});
    setShowForm(true); // show form instead of modal
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setFile(null);
    setIsEditMode(true);
    setErrors({});
    setShowForm(true);
  };

  const handleCancelForm = () => {
    setShowForm(false);
    setFormData({
      supplier_id: "",
    order_no: "",
    warehouse_id: warehouse_id,
    bill_date: "",
    due_date: "",
    sub_total: "",
    discount:"",
    grand_total:"",
    remarks:"",
    status: 0,
    });
    setFile(null);
    setErrors({});
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = {};
  if (!formData.supplier_id) newErrors.supplier_id = "Supplier is required";
  if (!formData.bill_date) newErrors.bill_date = "Bill date is required";

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    toast.warning("Please correct the highlighted fields");
    return;
  }

  try {
    setLoading(true);

    // Build payload according to your required format
    const payload = {
      supplier_id: formData.supplier_id,
      order_no: formData.grn_id || "",
      warehouse_id: formData.warehouse_id,
      bill_date: formData.bill_date,
      due_date: formData.due_date,
      sub_total: parseFloat(formData.sub_total) || 0,
      discount: parseFloat(formData.discount) || 0,
      grand_total: parseFloat(formData.grand_total) || 0,
      remarks: formData.remarks,
      status: parseInt(formData.status) || 0,
      grn_number: formData.grn_number || "",
      // grn_id: formData.grn_id || "",
      details: items.map(item => ({
        product_id: item.product_id,
        qty: parseFloat(item.qty) || 0,
        unit_price: parseFloat(item.unit_price) || 0,
        total: parseFloat(item.total) || 0
      }))
    };

    let res;
    if (isEditMode && formData.id) {
      res = await axios.put(`${var_api}veemart-billing/update/${formData.id}`, payload);
    } else {
      res = await axios.post(`${var_api}veemart-billing/post`, payload);
    }

    toast.success(res?.data?.message || "Billing record saved successfully!");
    setShowForm(false);
    fetchBillingData();
  } catch (err) {
    if (err?.response?.data?.errors) setErrors(err.response.data.errors);
    toast.error(err?.response?.data?.message || "Failed to save record");
  } finally {
    setLoading(false);
  }
};

const [items, setItems] = useState([]);

const handleAddRow = () => {
  setItems((prev) => [
    ...prev,
    { product_id: "", qty: "", unit_price: "",total:"", customer_id: "" }
  ]);
};

const handleRemoveRow = (index) => {
  setItems((prev) => prev.filter((_, i) => i !== index));
};

const handleItemChange = (index, field, value) => {
  const updated = [...items];
  updated[index][field] = value;

  if (field === "qty" || field === "unit_price") {
    const qty = parseFloat(updated[index].qty) || 0;
    const price = parseFloat(updated[index].unit_price) || 0;
    updated[index].total = qty * price;
  }

  setItems(updated);
};


useEffect(() => {
  const sub = items.reduce((sum, item) => {
    return sum + (parseFloat(item.total) || 0);
  }, 0);

  setFormData(prev => ({
    ...prev,
    sub_total: sub.toFixed(2)   // subtotal update
  }));
}, [items]);
// AUTO CALCULATE GRAND TOTAL WHEN SUBTOTAL OR DISCOUNT CHANGES
useEffect(() => {
  const sub = parseFloat(formData.sub_total) || 0;
  const disc = parseFloat(formData.discount) || 0;

  const grand = sub - disc;

  setFormData(prev => ({
    ...prev,
    grand_total: grand.toFixed(2)
  }));
}, [formData.sub_total, formData.discount]);


const bulkFilteredProducts = productData.filter((p) =>
  p.product_name.toLowerCase().includes(bulkSearch.toLowerCase())
);
const handleBulkAdd = (product) => {
  if (!bulkItems.find((i) => i.id === product.id)) {
    setBulkItems([...bulkItems, { ...product, qty: 1 }]);
  }
};

const handleBulkQtyChange = (index, qty) => {
  setBulkItems(prev =>
    prev.map((item, i) => (i === index ? { ...item, qty } : item))
  );
};

const handleBulkRemove = (index) => {
  setBulkItems(prev => prev.filter((_, i) => i !== index));
};


const handleDraftSelect = async (draft) => {
  setSelectedDraft(draft);

  try {
    const res = await axios.get(
      `${var_api}veemart-billing/get/${draft.id}`
    );

    const detailsOnly = Array.isArray(res.data?.details)
      ? res.data.details
      : [];

    setBillingData(detailsOnly); // <-- Only details
    setShowDraftDetails(true);
  } catch (err) {
    toast.error("Failed to fetch billing details");
    setBillingData([]);
  }
};

const getProductName = (id) => {
  const p = productData.find((item) => item.id === id);
  return p ? p.product_name : "-";
};




const updateStatus = async (id, newStatus) => {
  try {
    const payload = {
      id: id,
      status: newStatus
    };

    await axios.put(`${var_api}veemart-billing/update/${id}`, payload);

    toast.success(
      newStatus === 1 ? "Marked as OPEN successfully" : "Marked as PAID successfully"
    );

    // Refresh billing list
    fetchBillingData();

    // Close details screen
    setShowDraftDetails(false);

  } catch (error) {
    toast.error("Failed to update status");
    console.error(error);
  }
};

const getRibbon = (status) => {
  if (status === 0) return { text: "DRAFT", color: "#6c757d" };   // Grey
  if (status === 1) return { text: "OPEN", color: "#007bff" };    // Blue
  if (status === 2) return { text: "PAID", color: "#28a745" };    // Green
};


  const filteredData = billingData.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      {initialLoading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status"></div>
          <div>Loading data...</div>
        </div>
      ) : (
        <>
          {/* TABLE VIEW */}
{!showForm && !showDraftDetails && (           
   <Card>
              <Card.Body>
                <div className="d-flex justify-content-end mb-3 gap-2">
                  <input
                    type="text"
                    className="form-control w-auto"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                  />
                  <Button variant="secondary" onClick={handleAddClick}>Add</Button>
                </div>

                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>{tableHeaders.map((header, idx) => <th key={idx}>{header}</th>)}</tr>
                    </thead>
                    <tbody>
                      {paginatedData.length === 0 ? (
                        <tr>
                          <td colSpan={tableHeaders.length} className="text-center text-muted py-3">No data found</td>
                        </tr>
                      ) : (
                        paginatedData.map((item, idx) => (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          
                            <td>{getSupplierName(item.supplier_id)}</td>
                            <td>{item.bill_no}</td>
                             <td>{formatDate(item.bill_date)}</td>
                             <td>{formatDate(item.due_date)}</td>
         <td>
  <span
    style={{
      fontWeight: "bold",
      textTransform: "uppercase",
      color:
        item.status === 0
          ? "#e30c0cff"
          : item.status === 1
          ? "#007bff"
          : "#28a745",
      cursor: "pointer"
    }}
    onClick={() => handleDraftSelect(item)}
  >
    {item.status === 0
      ? "Draft"
      : item.status === 1
      ? "Open"
      : "Paid"}
  </span>
</td>





                            <td >
                              <Link to="#" className="btn shadow btn-xs sharp me-1" style={{ backgroundColor: "#007bff", color: "white" }} onClick={() => handleEditClick(item)}>
                                <i className="fas fa-pencil-alt"></i>
                              </Link>
                               <button
                              className="btn shadow btn-xs sharp"
                              style={{ backgroundColor: "#28a745", color: "white" }}
                              title="View Billing Details"
                              onClick={() => {
                                localStorage.setItem("bill_id", item.id);
                                localStorage.setItem("bill_no", item.bill_no);
                                navigate(`/billing-details?bill_id=${encodeURIComponent(item.id)}`);
                              }}
                            >
                              <i className="fas fa-cubes"></i>
                            </button>
                            </td>
                            
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-end mt-3">
                    {[...Array(totalPages)].map((_, idx) => (
                      <Button
                        key={idx}
                        variant={currentPage === idx + 1 ? "primary" : "light"}
                        onClick={() => setCurrentPage(idx + 1)}
                        className="me-1"
                      >
                        {idx + 1}
                      </Button>
                    ))}
                  </div>
                </div>
              </Card.Body>
            </Card>
          )}

          {/* FORM VIEW */}
{showForm && !showDraftDetails && (            <Card>
              <Card.Body>
               <h4 className="fw-bold mb-0 text-primary">
        {isEditMode ? "Edit Billing " : "Add Billing"}
      </h4>
      <hr></hr>
      <br></br>
      
                <Form onSubmit={handleSubmit}>
                  <Row className="gy-3">
                         <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold">Supplier *</Form.Label>
              <Select
                name="supplier_id"
                value={
                  supplierData
                    .map((sup) => ({ value: sup.id, label: sup.supplier_name }))
                    .find((opt) => opt.value === formData.supplier_id) || null
                }
                options={supplierData.map((sup) => ({
                  value: sup.id,
                  label: sup.supplier_name,
                }))}
                onChange={(selected) =>
                  setFormData((prev) => ({ ...prev, supplier_id: selected ? selected.value : "" }))
                }
                placeholder="Select Supplier"
                isClearable
                isSearchable
              />
              {errors.supplier_id && (
                <div className="text-danger small">{errors.supplier_id}</div>
              )}
            </Form.Group>
          </Col>

                   
                    <Col md={6}>
                      <Form.Group>
  <Form.Label className="fw-semibold">Order Number</Form.Label>
 <Select
  name="grn_number"
 value={
  grnData
    .map((grn) => ({
      value: grn.id,
      label: grn.grn_number
    }))
    .find((opt) => opt.value === formData.grn_id) || null
}

  options={grnData.map((grn) => ({
    value: grn.id,         // 🔥 pass GRN ID
    label: grn.grn_number,
  }))}

  onChange={async (selected) => {
    const grn_id = selected ? selected.value : "";
    const grn_number = selected ? selected.label : "";

    // Update Form Data
    setFormData(prev => ({
      ...prev,
      grn_number: grn_number,
      grn_id: grn_id,    // 🔥 store GRN ID also
    }));

    if (!grn_id) {
      setItems([]);
      return;
    }

    // 🔥 Fetch GRN Details using GRN ID
    const grnDetails = await fetchGrnDetails(grn_id);

    // Convert GRN Products → Item table
   const formattedItems = grnDetails.map(d => {
  const product = productData.find(p => p.id === d.product_id);

  return {
    product_id: d.product_id,
    product_name: product ? product.product_name : "",
    qty: d.required_qty,
    unit_price: d.unit_price || 0,
    total: (parseFloat(d.required_qty) * parseFloat(d.unit_price)).toFixed(2),
    customer_id: ""
  };
});


    setItems(formattedItems);
  }}

  placeholder="Select GRN Number"
  isClearable
  isSearchable
/>

</Form.Group>

                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Bill Date <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="date" name="bill_date" value={formData.bill_date} onChange={handleInputChange} />
                        {errors.bill_date && <div className="text-danger small mt-1">{errors.bill_date}</div>}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Due Date</Form.Label>
                        <Form.Control type="date" name="due_date" value={formData.due_date} onChange={handleInputChange} />
                      </Form.Group>
                    </Col>
                     <Col md={6}>
                      <Form.Group>
                        <Form.Label>Reamrks</Form.Label>
                        <Form.Control type="text" name="remarks" value={formData.remarks} onChange={handleInputChange} placeholder="Enter remarks" />
                      </Form.Group>
                    </Col>
                    <h5 className="fw-bold text-secondary border-bottom pb-2 mt-4">Item Table</h5>

<Table bordered hover responsive className="shadow-sm rounded">
  <thead className="bg-light text-center">
    <tr>
      <th>Product</th>
      <th>Qty</th>
      <th>Unit Price</th>
      <th>Total</th>
      <th>Customer</th>
      <th>Action</th>
    </tr>
  </thead>

  <tbody>
    {items.length === 0 ? (
      <tr>
        <td colSpan={5} className="text-center text-muted py-3">
          No items added yet
        </td>
      </tr>
    ) : (
      items.map((item, idx) => (
        <tr key={idx}>
          {/* PRODUCT DROPDOWN */}
           <td> <Form.Control type="text" value={item.product_name} onChange={(e) => handleItemChange(idx, "product_name", e.target.value)} placeholder="Enter product" className="shadow-sm rounded" /> </td>
            
          {/* QTY */}
          <td>
            <Form.Control
              type="number"
              value={item.qty}
              onChange={(e) => handleItemChange(idx, "qty", e.target.value)}
              placeholder="Qty"
              className="shadow-sm rounded"
            />
          </td>

          {/* Unit */}
          <td>
            <Form.Control
              type="number"
              value={item.unit_price}
              onChange={(e) => handleItemChange(idx, "unit_price", e.target.value)}
              placeholder="Unit Price"
              className="shadow-sm rounded"
            />
          </td>
            {/* total */}
          <td>
            <Form.Control
              type="number"
              value={item.total}
              onChange={(e) => handleItemChange(idx, "total", e.target.value)}
              placeholder="Total"
              className="shadow-sm rounded"
            />
          </td>

          {/* CUSTOMER DROPDOWN */}
      <td>
 <Select
  value={
    customerData
      .map((c) => ({
        value: c.id,
        label: `${c.customer_name} (${c.customer_mobile_whatsapp})`,
      }))
      .find((opt) => opt.value === item.customer_id) || null
  }
  options={customerData.map((c) => ({
    value: c.id,
    label: `${c.customer_name} (${c.customer_mobile_whatsapp})`,
  }))}
  onChange={(selected) =>
    handleItemChange(idx, "customer_id", selected ? selected.value : "")
  }
  placeholder="Select Customer"
  isSearchable
  isClearable

  /* 🔥 THIS IS THE FIX 🔥 */
  menuPortalTarget={document.body}

  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
    menu: (base) => ({ ...base, zIndex: 9999999 }),
    control: (base) => ({
      ...base,
      minHeight: "45px",
    }),
  }}
/>

</td>


          {/* DELETE BUTTON */}
          <td className="text-center">
            <Button
              variant="danger"
              size="sm"
              className="rounded-pill px-3"
              onClick={() => handleRemoveRow(idx)}
            >
              Delete
            </Button>
          </td>
        </tr>
      ))
    )}
  </tbody>
</Table>

{/* ADD ROW BUTTONS */}
<div className="d-flex gap-4 mb-4">
  <Button variant="link" className="p-0 fw-semibold" onClick={handleAddRow}>
    + Add New Row
  </Button>

  <Button
    variant="link"
    className="p-0 fw-semibold"
    onClick={() => setShowBulkModal(true)}
  >
    + Add Items in Bulk
  </Button>
</div>
<div
  style={{
    width: "300px",
    height: "300px",
    padding: "20px",
    borderRadius: "15px",
    background: "#ffffff",
    boxShadow: "0 4px 12px rgba(185, 168, 168, 0.15)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }}
>

  {/* Title */}
  <h5
    style={{
      textAlign: "center",
      fontWeight: "bold",
      marginBottom: "20px",
      color: "#3d3b3bff"
    }}
  >
    Billing Summary
  </h5>

  {/* Summary Items */}
  <div style={{ fontSize: "16px", lineHeight: "32px" }}>
    <div className="d-flex justify-content-between">
      <span>Sub Total:</span>
      <span>₹ {formData.sub_total || "0.00"}</span>
    </div>

    <div className="d-flex justify-content-between align-items-center">
  <span>Discount:</span>

  <Form.Control
    type="number"
    value={formData.discount}
    onChange={(e) =>
      setFormData(prev => ({
        ...prev,
        discount: e.target.value
      }))
    }
    style={{ width: "120px", textAlign: "right" }}
  />
</div>


    <hr style={{ marginTop: "15px", marginBottom: "15px" }} />

    <div
      className="d-flex justify-content-between"
      style={{ fontWeight: "bold", fontSize: "18px" }}
    >
      <span>Grand Total:</span>
      <span>₹ {formData.grand_total || "0.00"}</span>
    </div>
  </div>
</div>
                  </Row>

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button variant={loading ? "secondary" : (isEditMode ? "warning" : "secondary")} type="submit" disabled={loading}>
                      {loading ? "Saving..." : isEditMode ? "Update" : "Save as Draft"}
                    </Button>
<Button
  variant="danger"
  onClick={() => setShowCancelConfirm(true)}
  disabled={loading}
>
  Cancel
</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          )}
        </>
      )}

{showDraftDetails && selectedDraft && (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #f8f9fa, #e9ecef)",
      padding: "20px",
    }}
  >
    <Card
      className="shadow-lg border-0"
      style={{
        width: "100%",
        maxWidth: "1400px",
        borderRadius: "16px",
        overflow: "hidden",
      }}
    >
      <Card.Body className="p-0">
        <Row className="g-0">

       {/* LEFT PANEL: Draft List */}
<Col md={3} style={{ backgroundColor: "#f8f9fa", borderRight: "1px solid #dee2e6", minHeight: "100vh" }}>
  <div className="p-4">
<h5 className="fw-bold mb-4 text-dark">
      BILL: {selectedDraft.bill_no}
    </h5>
    <Card
      className="shadow-sm border-0 mb-4 hover-shadow"
      style={{
        color: "#000", // black text
        borderRadius: "0px", // square shape
        cursor: "pointer",
        transition: "all 0.3s ease",
      }}
      onClick={() => handleDraftSelect(selectedDraft)}
    >
      <div className="p-3">
        <Row>
          <Col md={6}>
            <p className="mb-2">
              <strong>Supplier:</strong>{" "}
              <span>{getSupplierName(selectedDraft.supplier_id)}</span>
            </p>
            <p className="mb-2">
              <strong>Bill No:</strong>{" "}
              <span>{selectedDraft.bill_no}</span>
            </p>
          </Col>

          <Col md={6} className="text-md-end">
            <p className="mb-2">
              <strong>Date:</strong>{" "}
              <span>{formatDate(selectedDraft.bill_date)}</span>
            </p>
          
          </Col>
        </Row>
      </div>
    </Card>
  </div>

  <style jsx>{`
    .hover-shadow:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }
  `}</style>
</Col>




          {/* RIGHT PANEL: Draft Details */}
          <Col md={9}>
            <div className="p-4">

              {/* Top Header */}
              <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                <div className="d-flex align-items-center gap-3">
                   <Button 
                    variant="outline-secondary" 
                    size="sm" 
                    onClick={() => window.location.reload()}
                  >
                    <i className="fas fa-arrow-left me-2"></i>Back
                  </Button>
                  <h4 className="fw-bold mb-0">Billing #{selectedDraft.bill_no}</h4>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <Button variant="primary" size="sm" onClick={() => handleEditClick(selectedDraft)}>
                    <i className="fas fa-edit me-2"></i>Edit
                  </Button>
 <Button
      variant="success"
      size="sm"
      onClick={() => updateStatus(selectedDraft.id, 1)}
    >
      Mark as Open
    </Button>

    <Button
      variant="danger"
      size="sm"
      onClick={() => updateStatus(selectedDraft.id, 2)}
    >
      Mark as Paid
    </Button>
                  {/* <Dropdown>
                    <Dropdown.Toggle variant="outline-secondary" size="sm">
                      <i className="fas fa-file-pdf me-2"></i>PDF / Print
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={handleDownloadPDF}>Download PDF</Dropdown.Item>
                      <Dropdown.Item onClick={handlePrint}>Print</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                </div>
              </div>

              {/* STATUS RIBBON + DETAILS CARD */}
              <div className="position-relative d-flex justify-content-center mb-4">
                <Card
                  className="shadow border-0 position-relative"
                  style={{
                    width: "100%",
                    maxWidth: "800px",
                    borderRadius: "12px",
                    backgroundColor: "#fff",
                  }}
                >
                  {/* Ribbon */}
                 <div
  style={{
    position: "absolute",
    top: "20px",
    left: "-30px",
    backgroundColor:
      selectedDraft.status === 0
        ? "#6c757d"       // Draft (Grey)
        : selectedDraft.status === 1
        ? "#007bff"       // Open (Blue)
        : "#28a745",      // Paid (Green)
    color: "#fff",
    transform: "rotate(-45deg)",
    width: "150px",
    textAlign: "center",
    padding: "5px 0",
    fontWeight: "600",
    fontSize: "12px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
  }}
>
  {selectedDraft.status === 0
    ? "DRAFT"
    : selectedDraft.status === 1
    ? "OPEN"
    : "PAID"}
</div>


                  {/* Main Details */}
                  <Card.Body className="p-5">

                    <div className="text-center mb-5">
                      <h2 className="fw-bold" style={{ fontSize: "32px" }}>BILLING</h2>
                    </div>

                    <Row className="mb-5">
                      <Col md={6}>
                        <p><strong>Supplier:</strong> {getSupplierName(selectedDraft.supplier_id)}</p>
                        <p><strong>Bill No:</strong> {selectedDraft.bill_no}</p>
                      </Col>

                      <Col md={6} className="text-end">
                       <p><strong>Date:</strong> {formatDate(selectedDraft.bill_date)}</p>

<p><strong>Status:</strong> {getRibbon(selectedDraft.status).text}</p>
                      </Col>
                    </Row>

                    {/* Item Table */}
                    <div className="table-responsive mb-5">
                      <table className="table table-bordered">
                        <thead style={{ backgroundColor: "#343a40", color: "#fff" }}>
                          <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th className="text-end">Qty</th>
                            <th className="text-end">Unit Price</th>
                            <th className="text-end">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                         {billingData.map((item, index) => (
  <tr key={index}>
    <td>{index + 1}</td>
                              <td>{getProductName(item.product_id)}</td>
    <td>{item.qty}</td>
    <td>{item.unit_price}</td>
    <td>{item.total}</td>
  </tr>
))}

                        </tbody>
                      </table>
                    </div>

                    {/* Billing Summary */}
                    <Row className="justify-content-end">
                      <Col md={6}>
                        <table className="table table-sm">
                          <tbody>
                            <tr>
                              <td className="text-end border-0"><strong>Sub Total</strong></td>
                              <td className="text-end border-0">₹ {selectedDraft.sub_total}</td>
                            </tr>
                            <tr>
                              <td className="text-end border-0"><strong>Discount</strong></td>
                              <td className="text-end border-0">₹ {selectedDraft.discount}</td>
                            </tr>
                            <tr>
                              <td className="text-end border-0 fw-bold"><strong>Grand Total</strong></td>
                              <td className="text-end border-0 fw-bold">₹ {selectedDraft.grand_total}</td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                    </Row>

                  </Card.Body>
                </Card>
              </div>

            </div>
          </Col>

        </Row>
      </Card.Body>
    </Card>
  </div>
)}





<Modal show={showBulkModal} onHide={() => setShowBulkModal(false)} size="xl">
  <Modal.Header closeButton>
    <Modal.Title>Add Items in Bulk</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="row">
      
      {/* LEFT SIDE PRODUCT LIST */}
      <div className="col-md-6 border-end" style={{ maxHeight: "70vh", overflowY: "auto" }}>
        
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Search products..."
          value={bulkSearch}
          onChange={(e) => setBulkSearch(e.target.value)}
        />

        {bulkFilteredProducts.map((product, i) => (
          <div key={i} className="d-flex justify-content-between align-items-center border-bottom py-2">
            <span>{product.product_name}</span>

            <button
              className="btn btn-outline-danger btn-sm rounded"
              onClick={() => handleBulkAdd(product)}
            >
              +
            </button>
          </div>
        ))}
      </div>

      {/* RIGHT SIDE SELECTED LIST */}
      <div className="col-md-6" style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <h6 className="fw-bold">Selected Items (Qty)</h6>

        {bulkItems.length === 0 ? (
          <p className="text-muted mt-3">No items selected</p>
        ) : (
          bulkItems.map((item, idx) => (
            <div key={idx} className="d-flex justify-content-between align-items-center border-bottom py-2">
              
              <div>
                <strong>{item.product_name}</strong>
              </div>

              <div className="d-flex align-items-center gap-2">
                <input
                  type="number"
                  value={item.qty}
                  min="1"
                  className="form-control form-control-sm"
                  style={{ width: "70px" }}
                  onChange={(e) => handleBulkQtyChange(idx, e.target.value)}
                />
                <button className="btn btn-danger btn-sm" onClick={() => handleBulkRemove(idx)}>X</button>
              </div>

            </div>
          ))
        )}
      </div>

    </div>
  </Modal.Body>

 <Modal.Footer>

  <Button
    style={{
      backgroundColor: "#007bff",
      borderColor: "#007bff",
      color: "#fff"
    }}
    onClick={() => {
      setItems(prev => [
        ...prev,
        ...bulkItems.map(b => ({
          product_id: b.id,
          product_name: b.product_name,
          qty: b.qty,
          unit_price: "",
          total:"",
          customer_id: ""
        }))
      ]);
      setBulkItems([]);
      setShowBulkModal(false);
    }}
  >
    Add Products
  </Button>

  <Button
    style={{
      backgroundColor: "#6c757d",
      borderColor: "#6c757d",
      color: "#fff"
    }}
    onClick={() => setShowBulkModal(false)}
  >
    Cancel
  </Button>

</Modal.Footer>

</Modal>
<Modal
  show={showCancelConfirm}
  onHide={() => setShowCancelConfirm(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title className="text-danger fw-bold">
      <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
      Leave this page?
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p>If you leave, your unsaved changes will be discarded.</p>
  </Modal.Body>

  <Modal.Footer className="d-flex justify-content-end">
    <Button
      variant="primary"
      className="px-4"
      style={{ borderRadius: "6px", backgroundColor: "#007bff", border: "none" }}
      onClick={() => setShowCancelConfirm(false)}
    >
      Stay Here
    </Button>

    <Button
      variant="light"
      className="px-4 text-dark border"
      style={{ borderRadius: "6px", backgroundColor: "#e0e0e0" }}
      onClick={() => {
        setShowCancelConfirm(false);
        handleCancelForm(); // 🔥 call the existing form reset logic
      }}
    >
      Leave & Discard Changes
    </Button>
  </Modal.Footer>
</Modal>

      <ToastContainer />
    </>
  );
};

export default BillingMaster;
